export default __webpack_public_path__ + "static/media/Afreul-Kaium-Joy_Resume-01.14ffebf9.pdf";